
// Ensure GSAP and ScrollTrigger are registered
gsap.registerPlugin(ScrollTrigger);

// Array of words to cycle through
const words = ["art", "handcrafted", "contemporary", "jewellery", "YCCIJ"];
const changingWord = document.getElementById("changing-word");
changingWord.textContent = "bling";

// Initial animation to make the first word appear in a nicer way
gsap.fromTo(
  changingWord,
  { opacity: 0, scale: 0.8 }, // Start state: faded and smaller
  { 
    opacity: 1, 
    scale: 1, 
    duration: 2, // Duration for initial appearance
    ease: 'power2.out',
    // onStart: () => {
    //   changingWord.textContent = words[0]; // Set the first word before the animation starts
    // }
  }
);

// ScrollTrigger configuration
let tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".scroll-section",
    pin: true, // Pin the section while active
    start: "center center", // Start when the section reaches the center of the viewport
    end: "+=2000", // Increase this value for a much longer scrolling duration
    scrub: true, // Sync animation with scroll
    onUpdate: (self) => {
      // Calculate which word to display based on scroll progress
      const index = Math.floor(self.progress * (words.length)) ;

      if (index < words.length) {
        changingWord.textContent = words[index];
      }
    },
    snap: {
      snapTo: 'labels', // Snap to the closest label in the timeline
      duration: { min: 0.2, max: 3 }, // Snap duration constraints
      delay: 0.2, // Delay before snapping
      ease: 'power1.inOut' // Ease for the snap animation
    }
  }
});

// Add animations and labels to the timeline for each word
words.forEach((word, i) => {
    tl.addLabel(`word${i}`)
      .add(() => {
          changingWord.textContent = word;
      }, `word${i}`)
      .fromTo(
          changingWord,
          { opacity: 0, scale: 0.8 }, // Start state: faded and smaller
          { opacity: 1, scale: 1, duration: 2, ease: 'power2.out' }, // End state: fully visible and normal size
          `word${i}`
      );
});